import type { MouseEventHandler, ReactNode } from 'react';

export type LabelTheme =
  | 'purple'
  | 'red'
  | 'green'
  | 'yellow'
  | 'blue'
  | 'lightBlue'
  | 'light'
  | 'medium';

export type LabelSize = 'small' | 'large';

export interface LabelData {
  content: ReactNode;
  theme?: LabelTheme;
  bgColor?: string;
  textColor?: string;
  size?: LabelSize;
  tooltip?: string;
  onClick?: MouseEventHandler;
}

export interface LabelProps extends LabelData {}
